<template>
  <TabView :activeIndex="active" @tab-click="onTabClick($event)">
    <TabPanel
      v-for="(tab, index) in tabs"
      :key="index"
      :header="tab.name"
    ></TabPanel>
  </TabView>
</template>

<script>
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';

export default {
  name: 'CashFlowTabs',
  components: {
    TabView,
    TabPanel,
  },
  props: {
    tabs: Array,
  },
  data() {
    return { active: 0 };
  },
  created() {
    const index = this.tabs.findIndex((tab) => tab.route === this.$route.name);
    if (index !== -1) {
      this.active = index;
    }
  },
  methods: {
    onTabClick(event) {
      if (event.index === this.active) {
        return;
      }
      if (this.tabs?.[event.index]?.route) {
          this.$router.push({ name: this.tabs[event.index].route });
      }
    },
  },
};
</script>

<style scoped>
div >>> .p-tabview-panels {
  padding: 0;
}
div >>> .p-tabview-nav {
  background: unset;
}
div >>> a {
  background: unset !important;
}
</style>